import request from '@/util/request'

export const sendLogs = list =>
  request({
    url: '/api/blade-auth/usual/logs', // TODO: 请替换成自己的接口地址
    method: 'post',
    data: list
  })
